@let otherCategories = otherCategoriesSignal();

<wilson-working-time-section-wrapper
  [title]="'page.working_time.other.title' | translate"
  [isLoading]="isLoadingOtherCategories()"
  [shouldHide]="
    otherCategories.length === 0 && !isLoadingOtherCategories() && !hasError()
  "
>
  @if (otherCategories.length === 0 && hasError()) {
    <ion-label class="ion-padding">
      {{ 'general.n/a' | translate }}
    </ion-label>
  } @else {
    @for (otherCategory of otherCategories; track otherCategory.name) {
      <ion-col size="6">
        <wilson-worktime-metrics-card
          [header]="otherCategory.translatedName"
          [values]="[otherCategory.temporarySum, otherCategory.sum]"
          [unit]="otherCategory.wageReportUnit"
        />
      </ion-col>
    }
  }
</wilson-working-time-section-wrapper>
